export default {
  advancedPlanSettings: 'Configurações Avançadas do Plano',
  minimumWeeklySpend: 'Gasto Semanal Mínimo',
  minSpendInfo: 'Limites mínimos de investimento publicitário para uma semana individual, para cada canal de mídia. Esses limites não excluem as semanas sem investimento publicitário.',
  cancel: 'Cancelar',
  save: 'Salvar',
  positiveValueRequired: 'É necessário um valor positivo'
}
